import { mapEnumToOptions } from '@abp/ng.core';

export enum LocationDefinition {
  HOME = 'HOME',
  SECONDARY = 'SECONDARY',
  JOBSITE = 'JOBSITE',
}

export const locationTypeOptions = mapEnumToOptions(LocationDefinition);
